import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
interface CounterProps {
  value: number;
  prefix?: string;
  suffix?: string;
  className?: string;
}
export function Counter({
  value,
  prefix = '',
  suffix = '',
  className
}: CounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(reduce ? value : 0);
  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 1.4,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setDisplay(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, reduce, value]);
  return <span ref={ref} className={className} aria-label={`${prefix}${value.toLocaleString('en-US')}${suffix}`} data-id="element-536" data-mp="2lb6xjynqbccl">
      <span aria-hidden="true" data-id="element-537" data-mp="2q8fe5ut8b8bq">
        {prefix}
        {display.toLocaleString('en-US')}
        {suffix}
      </span>
    </span>;
}